export const ParameterValueSource = {
  Lilian: 'lilian',
  Manual: 'manual',
  Calculation: 'calculation',
}
